"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BasketBubbleControllerProps = require("./BasketBubbleControllerProps");
Object.keys(_BasketBubbleControllerProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BasketBubbleControllerProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasketBubbleControllerProps[key];
    }
  });
});
var _TestId = require("./TestId");
Object.keys(_TestId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TestId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TestId[key];
    }
  });
});
